<script>
	import VideoFeature from '$lib/Components/Layout/VideoFeature/VideoFeature.svelte';
	import thumb_uxt6iMknNMs from '$lib/Components/Youtube/images/uxt6iMknNMs.jpg?w=610';
</script>

<VideoFeature
	class="mt-6"
	backgroundColor="blue"
	title="SEE IT IN ACTION"
	posterImageSrc={thumb_uxt6iMknNMs}
	src="https://www.youtube.com/watch?v=uxt6iMknNMs"
>
	<p>
		What does a 70% reduction in noise sound like? Listen to how much the music
		is reduced even from inside the window!
	</p>
</VideoFeature>
